import Vue from 'vue';
import formatedDay from './formatedDay';
import currency from './currency';
import dateFormat from './dateFormat';

Vue.filter('formatedDay', formatedDay);
Vue.filter('currency', currency);
Vue.filter('date', dateFormat);



// WEBPACK FOOTER //
// ./assets/js/filters/index.js